module.exports = __webpack_public_path__ + "img/开启关闭同捆.27c462ca.svg";